import { Listbox, ListboxOption, ListboxLabel } from '@/components/catalyst/listbox'

export interface FormSelectOption {
  value: string
  label: string
  /** Per-option disable — option still listed but greyed out, not selectable. */
  disabled?: boolean
}

interface FormSelectProps {
  value: string
  onChange: (value: string) => void
  options: FormSelectOption[]
  placeholder?: string
  className?: string
  /** When true the listbox is rendered greyed-out and clicks are ignored. */
  disabled?: boolean
}

export default function FormSelect({ value, onChange, options, placeholder, className, disabled }: FormSelectProps) {
  return (
    <Listbox value={value} onChange={onChange} placeholder={placeholder || 'Select...'} className={className} disabled={disabled}>
      {options.length === 0 ? (
        <ListboxOption value="" disabled>
          <ListboxLabel className="text-zinc-400">No Options</ListboxLabel>
        </ListboxOption>
      ) : (
        options.map((opt, idx) => (
          <ListboxOption key={`${opt.value ?? idx}`} value={opt.value} disabled={opt.disabled}>
            <ListboxLabel className={opt.disabled ? 'text-zinc-400 dark:text-zinc-500' : undefined}>
              {opt.label}
            </ListboxLabel>
          </ListboxOption>
        ))
      )}
    </Listbox>
  )
}
